/**
 *
 * ReportTabs
 *
 */
import { memo, useEffect, useState } from 'react';

import { Col, Row, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { BooleanParam, useQueryParam, withDefault } from 'use-query-params';

import { ReportForm } from '../../components/ReportForm';
import { ReportPeriodicity } from '../../components/ReportPeriodicity';
import { useReport } from '../../services/hooks';
import { label } from '../../translation';
import { EditReport } from '../editReport';

interface Props {
  reportId?: string;
}

interface ReportTabParams {
  tab?: string;
  reportId: string;
}

const ReportEditForm = (props: Props) => {
  const { data } = useReport(props.reportId as string);

  return <>{data && <ReportForm defaultValue={data} />}</>;
};

// eslint-disable-next-line react/display-name
export const ReportTabs = memo((props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();

  const { tab, reportId } = useParams<Record<string, string>>();
  const [key, setKey] = useState(tab);

  const navigate = useNavigate();
  const location = useLocation();
  const url = location.pathname;
  const [disabled] = useQueryParam('disabled', withDefault(BooleanParam, false));
  useEffect(() => {
    if (tab !== key) {
      setKey(tab);
    }
  }, [tab, key]);

  return (
    <Tabs
      id="controlled-tab-example"
      unmountOnExit={true}
      activeKey={key}
      className="nav-fill"
      onSelect={(k) => navigate(url.replace(key as string, k as string))}
    >
      <Tab disabled={disabled} eventKey="general" title={label(t, 'tabEditReport')}>
        <Row className="mt-2">
          <Col>
            <EditReport id={reportId ?? ''} />
          </Col>
        </Row>
      </Tab>
      <Tab disabled={disabled} eventKey="periodicity" title={label(t, 'tabPeriodicity')}>
        <Row className="mt-2">
          <Col>
            <ReportPeriodicity reportId={reportId ?? ''} />
          </Col>
        </Row>
      </Tab>
    </Tabs>
  );
});
